import React, { useMemo } from 'react';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { Url } from '@wix/da-url';
import TierSidebarCard from '../../../DeviationViews/TierSidebarCard';
import SidebarBlock from '../SidebarBlock';
import Placeholder from '../Placeholder';
import lodashTimes from 'lodash/times';
import s from './TiersBlock.scss';
export var TiersBlock = function (_a) {
    var author = _a.deviation.author, streamKey = _a.streamKey, _b = _a.tiers, tiers = _b === void 0 ? [] : _b, isLoading = _a.isLoading;
    var seeAll = useMemo(function () { return ({
        href: (author === null || author === void 0 ? void 0 : author.username) && Url.userLink(author.username, 'subscribe'),
        biData: {
            creatorid: author === null || author === void 0 ? void 0 : author.useridUuid,
        },
    }); }, [author === null || author === void 0 ? void 0 : author.username, author === null || author === void 0 ? void 0 : author.useridUuid]);
    if (!tiers.length && !isLoading) {
        return null;
    }
    return (React.createElement(BiLoggerContextProvider, { value: { sectionname: streamKey } },
        React.createElement(SidebarBlock, { headerClassname: s['header'], titleClassname: s['header-text'], linkClassname: s['header-text'], streamKey: streamKey, isLoading: isLoading, seeAll: seeAll },
            !isLoading &&
                tiers
                    .filter(function (tier) { return !!tier; }) // backend can do strange stuff...
                    .slice(0, 3)
                    .map(function (tier) { return (React.createElement(TierSidebarCard, { key: tier.deviationId, className: s['tier'], tier: tier })); }),
            isLoading &&
                lodashTimes(3, function (index) { return (React.createElement(Placeholder, { key: index, className: s['tier'] })); }))));
};
TiersBlock.displayName = 'TiersBlock';
export default TiersBlock;
//# sourceMappingURL=TiersBlock.js.map